import * as React from 'react';
import { IRedirect, PropertyHelper, clone } from '../../helpers/index';
import { Button, ButtonType, IDropdownOption } from 'office-ui-fabric-react';
import { QueryStringParameter } from './query-string-parameter';
import { IQueryStringParameter } from '../../helpers/interfaces';

interface IQueryStringBuilderProps {
    queryString: string;
    onChange: (queryString: string) => void;
    outputOptions?: IDropdownOption[];
}

export class QueryStringBuilder extends React.Component<IQueryStringBuilderProps, {}> {


    render() {
             
        let parameters = this.getParameters();
        return (<div>
            
            <div>
                <Button icon="Add" buttonType={ ButtonType.normal } onClick={this.addParameter} title="Add parameter">Add</Button>            
            </div>
            
            {
                parameters.length ? 
                <table>
                    <thead>
                        <tr>
                            <th>Key</th>
                            <th>Value</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {parameters.map((parameter, index) => <QueryStringParameter key={index} index={index} parameter={parameter} updateKey={this.updateKey} updateValue={this.updateValue} removeParameter={this.removeParameter} outputOptions={this.props.outputOptions} />)}
                    </tbody>
                </table>
                : null
            }
        </div>);
    }

    private getParameters = () : IQueryStringParameter[] => {
        let parameters: IQueryStringParameter[] = (this.props.queryString || "").length ? this.props.queryString.split("&").map(pair => {
            let parts = pair.split("=");
            let key = parts[0] || "";
            let value = parts[1] || "";
            return {
                key: JSON.stringify({ text: key, markup: key }),
                value: JSON.stringify({ text: value, markup: value })
            }
        }) : [];

        return parameters;
    }

    private addParameter = () => {
        let parameters = this.getParameters();
        parameters.push({
            key: JSON.stringify({ text: "key", markup: "key" }),
            value: JSON.stringify({ text: "value", markup: "value" })
        })
        
        this.emitOnChange(parameters);
    }

    private updateKey = (index: number, key: string) => {
        this.updateParameter(index, "key", key);        
    }
    
    private updateValue = (index: number, value: string) => {
        this.updateParameter(index, "value", value);
    }

    private updateParameter = (index: number, key: string, value: string) => {
        let parameters = this.getParameters();
        let parameter = clone(parameters[index]);
        parameter[key] = (value || "").replace(/[?&=]/g, "");
        parameters.splice(index, 1, parameter)
        this.emitOnChange(parameters);
    }
    
    private removeParameter = (index: number) => {
        let parameters = this.getParameters();
        parameters.splice(index, 1)
        this.emitOnChange(parameters);
    }

    private emitOnChange = (parameters: IQueryStringParameter[]) => {
        
        let queryString = parameters.map(parameter => `${JSON.parse(parameter.key).text}=${JSON.parse(parameter.value).text}`).join("&");
        this.props.onChange(queryString);
    }
}


// WEBPACK FOOTER //
// ./source/ts/components/redirect/query-string-builder.tsx